"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// from npm package react-material-snackbar which would not build
var SnackBar = /*#__PURE__*/
function (_React$Component) {
  _inherits(SnackBar, _React$Component);
  function SnackBar() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, SnackBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SnackBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      showSnackBar: false,
      timer: null,
      height: 60
    });
    _defineProperty(_assertThisInitialized(_this), "setHeight", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        el = _assertThisInitialize.el;
      if (el && el.clientHeight && _this.state.height !== el.clientHeight) {
        _this.setState({
          height: el.clientHeight
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideSnackbar", function () {
      clearTimeout(_this.state.timer);
      _this.setState({
        showSnackBar: false,
        timer: null
      });
      _this.props.onHideSnackbar && _this.props.onHideSnackbar();
    });
    return _this;
  }
  _createClass(SnackBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setHeight();
      if (this.props.show) {
        var timer = !this.props.delay ? null : setTimeout(this.hideSnackbar, this.props.delay);
        this.setState({
          showSnackBar: true,
          timer: timer
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var showSnackBar = this.state.showSnackBar;
      if (!nextProps.show) {
        clearTimeout(this.state.timer);
      }
      if (showSnackBar !== nextProps.show) {
        this.setState({
          showSnackBar: nextProps.show
        });
        clearTimeout(this.state.timer);
        var timer = nextProps.delay && nextProps.show ? setTimeout(function () {
          _this2.hideSnackbar();
        }, nextProps.delay) : null;
        this.setState({
          timer: timer
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.state.timer);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // eslint-disable-line camelcase
      var showSnackBar = this.state.showSnackBar;
      if (!nextProps.show) {
        clearTimeout(this.state.timer);
      }
      if (showSnackBar !== nextProps.show) {
        this.setState({
          showSnackBar: nextProps.show
        });
        clearTimeout(this.state.timer);
        var timer = nextProps.delay && nextProps.show ? setTimeout(function () {
          _this3.hideSnackbar();
        }, nextProps.delay) : null;
        this.setState({
          timer: timer
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var bsStyle = this.props.bsStyle;
      var _this$state = this.state,
        showSnackBar = _this$state.showSnackBar,
        height = _this$state.height;
      var icon;
      switch (bsStyle) {
        case 'info':
          icon = 'fa-info-circle';
          break;
        case 'success':
          icon = 'fa-check';
          break;
        case 'warning':
        case 'danger':
          icon = 'fa-exclamation-triangle';
          break;
        default:
          icon = 'fa-info-circle';
      }
      var snackbarStyle = {
        position: 'fixed',
        left: 0,
        right: 0,
        top: "-".concat(height + 30, "px"),
        transitionTimingFunction: 'ease-in-out',
        transition: '300ms',
        transform: showSnackBar ? "translateY(".concat(height + 50, "px)") : 'translateY(0px)',
        zIndex: '2000',
        visibility: showSnackBar ? 'visible' : 'hidden'
      };
      return _react["default"].createElement("div", {
        className: "snackbar snackbar-".concat(bsStyle),
        style: snackbarStyle,
        ref: function ref(el) {
          return _this4.el = el;
        } // eslint-disable-line no-return-assign
      }, _react["default"].createElement("div", {
        className: "snackbar-icon"
      }, _react["default"].createElement("i", {
        className: "fa ".concat(icon)
      })), _react["default"].createElement("div", {
        className: "snackbar-text"
      }, this.props.children), _react["default"].createElement("button", {
        type: "button",
        className: "close",
        "aria-hidden": "true",
        onClick: this.hideSnackbar
      }, "\xD7"));
    }
  }]);
  return SnackBar;
}(_react["default"].Component);
exports["default"] = SnackBar;
SnackBar.defaultProps = {
  bsStyle: 'success',
  show: false
};
SnackBar.propTypes = {
  bsStyle: _propTypes["default"].oneOf(['success', 'info', 'warning', 'danger']),
  show: _propTypes["default"].bool,
  delay: _propTypes["default"].number,
  children: _propTypes["default"].node,
  onHideSnackbar: _propTypes["default"].func
};